import { Record } from 'immutable';
const ErrorMessageTokens = Record({
  bouncedEmailAddress: null
}, 'ErrorMessageTokens');
export default ErrorMessageTokens;